// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle--left[data-v-0ea2f259]{position:absolute;left:0;bottom:15%;transform:translateX(-40%)}.circle--right[data-v-0ea2f259]{opacity:.2;position:absolute;right:0;top:0;transform:translateY(-20%)}", ""]);
// Exports
module.exports = exports;
